<template>
  <div class="booking-summary__packages booking-summary-callout booking-summary-callout--info">
    <strong class="callout-title">
        <svg width="25" height="30" viewBox="0 0 1792 1792">
            <path d="M1699 186q0 35-43 78l-632 632v768h320q26 0 45 19t19 45-19 45-45 19h-896q-26 0-45-19t-19-45 19-45 45-19h320v-768l-632-632q-43-43-43-78 0-23 18-36.5t38-17.5 43-4h1408q23 0 43 4t38 17.5 18 36.5z"/>
        </svg>
        <span>Interested in a package?</span>
    </strong>

    <select v-on:change="onChange" v-model="pack">
      <option :value="null">No thanks</option>
      <option :value="null" disabled selected>-----------------</option>
      <option
        v-for="pack in packages"
        v-bind:key="pack.id"
        v-bind:value="pack">
          {{ pack.label }}
      </option>
    </select>
  </div>
</template>

<script>
  import inputCheckbox from './inputCheckbox'

  export default {
    name: 'packageInput',
    props: [
      'packages',
      'value'
    ],
    data () {
      return {
        pack: this.value
      }
    },
    methods: {
      onChange () {
        this.$emit('input', this.pack)
      }
    },
    components: {
      inputCheckbox
    }
  }
</script>



// WEBPACK FOOTER //
// packageInput.vue?f21c335a